// src/features/users/types/index.ts

import { RaRecord } from 'react-admin';

// ============================================
// MODELOS DE DATOS
// ============================================

export interface User extends RaRecord {
  id: string;
  name: string;
  email: string;
  role: 'SuperAdmin' | 'GroupAdmin' | 'HotelAdmin' | 'Receptionist';
  staffUserIdCode?: string;
  hasPinConfigured: boolean;
  isActive: boolean;
  hotel?: {
    id: string;
    name: string;
  };
  group?: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt?: string;
}

export interface UserFormData {
  name: string;
  email: string;
  role: User['role'];
  password?: string;
  hotelId?: string;
  groupId?: string;
}

export interface UserValidationErrors {
  name?: string;
  email?: string;
  password?: string;
  role?: string;
  hotelId?: string;
  groupId?: string;
}

// ============================================
// UTILIDADES DE TIPO
// ============================================

/**
 * Normaliza los datos de usuario que vienen de la API
 */
export const normalizeUser = (apiUser: any): User => ({
  ...apiUser,
  id: apiUser.id,
  name: apiUser.name,
  email: apiUser.email,
  role: apiUser.role,
  staffUserIdCode: apiUser.staffUserIdCode,
  hasPinConfigured: apiUser.hasPinConfigured,
  isActive: apiUser.isActive,
  hotel: apiUser.hotel,
  group: apiUser.group,
  createdAt: apiUser.createdAt,
});

/**
 * Prepara los datos del formulario para enviarlos a la API
 */
export const prepareUserForAPI = (data: UserFormData): any => {
  const payload: any = {
    name: data.name,
    email: data.email,
    role: data.role,
  };
  if (data.password) {
    payload.password = data.password;
  }
  if (data.hotelId) {
    payload.hotelId = data.hotelId;
  }
  if (data.groupId) {
    payload.groupId = data.groupId;
  }
  return payload;
};